export default __webpack_public_path__ + "static/media/change-username.188de34d.svg";